import React from 'react';

import { CardInlineNotes, PackagingInfo, CardText } from '../../index';

type CardContentProps = {
  uuid: string,
  bundleDescription?: string,
  servings?: string,
  disclaimer?: string,
  subTitle?: string,
  stockQuantity?: string,
  isDisabled?: boolean,
  bundle?: any,
  items?: any[],
  mode?: 'MenuCard' | 'MealCard' | 'UpsellCard' | 'ReorderCard',
  cardType?: 'Card' | 'ListCard',
  showPackaging?: boolean,
  showFees?: boolean,
  showStockQuantity?: boolean,
  isTakeAway?: boolean,
  FeeInfoComponent?: React.ComponentType<any>,
};

export const BaseCardContent = ({
  uuid,
  bundleDescription,
  servings,
  disclaimer,
  subTitle,
  stockQuantity,
  isDisabled = false,
  bundle,
  items = [],
  mode = 'MenuCard',
  cardType = 'Card',
  showPackaging = true,
  showFees = true,
  showStockQuantity = true,
  isTakeAway = false,
  FeeInfoComponent,
}: CardContentProps) => {
  return (
    <>
      <CardText id={`${uuid}-description`} ariaHidden componentName="Description" mode={mode} cardType={cardType}>
        {bundleDescription}
      </CardText>

      <CardText id={`${uuid}-servings`} ariaHidden componentName="Servings" mode={mode} cardType={cardType}>
        {servings}
      </CardText>

      <CardText id={`${uuid}-disclaimer`} ariaHidden componentName="Disclaimer" mode={mode} cardType={cardType}>
        {disclaimer}
      </CardText>

      <CardText id={`${uuid}-subtitle`} ariaHidden componentName="Subtitle" mode={mode} cardType={cardType}>
        {subTitle}
      </CardText>

      {!isDisabled && showStockQuantity && (
        <CardText id={`${uuid}-stock`} ariaHidden componentName="StockQuantity" mode={mode} cardType={cardType}>
          {stockQuantity}
        </CardText>
      )}

      {(showPackaging || showFees) && (
        <CardInlineNotes>
          {showPackaging && bundle?.isPrepackaged && (
            <PackagingInfo
              ariaHidden
              Component={CardText}
              id={`${uuid}-packaging-info`}
              items={items}
              componentName="PackagingInfo"
              cardType={cardType}
              mode={mode}
            />
          )}

          {showFees && FeeInfoComponent && (
            <FeeInfoComponent
              ariaHidden
              Component={CardText}
              id={`${uuid}-fee-info`}
              isTakeAway={isTakeAway}
              items={items}
              componentName="Fees"
              cardType={cardType}
              mode={mode}
            />
          )}
        </CardInlineNotes>
      )}
    </>
  );
};
